import { render } from "./FormRadio.vue?vue&type=template&id=4f9195da"
import script from "./FormRadio.vue?vue&type=script&lang=js"
export * from "./FormRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__